document.addEventListener("DOMContentLoaded", () => {
  // Globally register
  gsap.registerPlugin(ScrollTrigger);

  /**
   * Fixes vh unit in touch devices
   *
   * @since   1.0
   */
  const setupVh = () => {
    const setVh = () => {
      // get the viewport height and we multiple it by 1% to get a value for a vh unit
      let vh = window.innerHeight * 0.01;

      // set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty(`--vh`, `${vh}px`);
    };

    setVh();
    window.addEventListener(`resize`, setVh, false);
  };

  /**
   * Chocks away!
   */
  setupVh();
});

// To avoid layout shift - refresh scroll trigger calculations
window.onload = () => {
  ScrollTrigger.refresh();
};

/**
 * Horizontal blob row component - animate on scroll
 */
if (!customElements.get("horizontal-blob-row")) {
  customElements.define(
    "horizontal-blob-row",
    class HorizontalBlobRow extends HTMLElement {
      constructor() {
        super();

        window.addEventListener("DOMContentLoaded", () => {
          this.init();
        });
      }

      init() {
        this.container = this.querySelector(".blob-container");
        this.data = JSON.parse(
          this.querySelector('[type="application/json"]').textContent,
        );

        this.generateBlobRow(this.data.size, this.data.size);
        this.handleAnimation();
      }

      generateBlobRow(width, height) {
        const viewportWidth = window.innerWidth;
        let gap = viewportWidth < 576 ? 10 : 35;

        const numBlobs = Math.floor((viewportWidth + gap) / (width + gap)); // +10 for the gap

        this.container.innerHTML = ""; // Clear any existing blobs
        for (let i = 0; i < numBlobs; i++) {
          const blobElement = createBlobHtmlElement(width, height);
          this.container.appendChild(blobElement);
        }
      }

      handleAnimation() {
        if (this.dataset.animate !== "true") return;

        gsap.to(this.container, {
          scrollTrigger: {
            trigger: this.container,
            id: this.container.id,
            start: "top bottom",
            end: "bottom top",
            markers: false,
            scrub: 1.5,
          },
          x: `${this.data.final_offset}%`,
        });
      }

      connectedCallback() {
        this._handleShopifyBlockSelect = (event) => {
          const block = event.target.closest(".blob-container");
          if (block) {
            this.init();
          }
        };

        document.addEventListener(
          "shopify:block:select",
          this._handleShopifyBlockSelect,
        );
        document.addEventListener(
          "shopify:block:deselect",
          this._handleShopifyBlockSelect,
        );
        document.addEventListener(
          "shopify:section:select",
          this._handleShopifyBlockSelect,
        );
        document.addEventListener(
          "shopify:section:deselect",
          this._handleShopifyBlockSelect,
        );
      }

      disconnectedCallback() {
        document.addEventListener(
          "shopify:block:select",
          this._handleShopifyBlockSelect,
        );
        document.addEventListener(
          "shopify:block:deselect",
          this._handleShopifyBlockSelect,
        );
        document.addEventListener(
          "shopify:section:select",
          this._handleShopifyBlockSelect,
        );
        document.addEventListener(
          "shopify:section:deselect",
          this._handleShopifyBlockSelect,
        );
      }
    },
  );
}

/**
 * Parallax Split Image Hero
 */
if (!customElements.get("parallax-split-hero")) {
  customElements.define(
    "parallax-split-hero",
    class ParallaxSplitHeroRow extends HTMLElement {
      constructor() {
        super();

        if (Shopify.designMode) {
          return;
        }

        this.image_one = this.querySelector(".layer_left img");
        this.image_two = this.querySelector(".layer_right img");
        this.image_logo = this.querySelector(".layer_logo img");

        this.init()
      }

      init() {
        const tl = gsap.timeline();
        const triggerParams = {
          trigger: this,
          start: "top 10%",
          end: "bottom 10%",
          scrub: 1.5,
          markers: false,
        };

        if (this.image_one) {
          tl.from(this.image_one, {
            y: 75,
            x: 15,
            opacity: 0,
            duration: 1,
            // scrollTrigger: {
            //   id: "image_one",
            //   ...triggerParams,
            // },
          }, 1);
        }

        if (this.image_two) {
          tl.from(this.image_two, {
            y: -50,
            x: -10,
            opacity: 0,
            duration: 1
            // scrollTrigger: {
            //   id: "image_two",
            //   ...triggerParams,
            // },
          }, 1);
        }

        if (this.image_logo) {
          tl.from(this.image_logo, {
            duration: 1,
            ease: "none",
            // scrollTrigger: {
            //   ...triggerParams,
            //   trigger: this.image_logo,
            //   start: "top 25%",
            //   end: "bottom 10%",
            //   id: "image_logo"
            // },
          }, ">-0.5");

          tl.to(this.image_logo, {
            opacity: 0,
            scrollTrigger: {
              ...triggerParams,
              trigger: this.image_logo,
              start: "top 25%",
              end: "bottom 10%",
              id: "image_logo"
            },
          }, ">");
        }
      }
    },
  );
}
